import React, { useEffect } from 'react';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import '../styles/BaseForm.css';
import fr from '../locales/fr';
import en from '../locales/en';

function Restart({ ws }) {

  const navigate = useNavigate();
  const location = useLocation();
  const browserLang = navigator.language || navigator.userLanguage;
  const language = browserLang.startsWith('fr') ? 'fr' : 'en';
  const translations = language === 'fr' ? fr : en;

  const allowed =
    location.state?.fromAuthorized ||
    sessionStorage.getItem('canAccessRestart');

  useEffect(() => {
    const handleWebSocketMessage = (event) => {
      const message = event.data;
      const ROOM = localStorage.getItem('UNITY');

      switch (message) {
        case ROOM + ":START":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessOnTV', 'true');
          navigate("/onTV", { state: { fromAuthorized: true } });
          break;
        case ROOM + ":ANSWER":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessAnswer', 'true');
          navigate("/answer", { state: { fromAuthorized: true } });
          break;
        case ROOM + ":WAIT":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessWaitingState', 'true');
          navigate("/waitingState", { state: { fromAuthorized: true } });
          break;
        case ROOM + ":VOTE":
          ws.onmessage = null;
          ws.send(ROOM + ":CHECKSTATE");
          sessionStorage.setItem('canAccessExportVote', 'true');
          navigate("/exportVote", { state: { fromAuthorized: true } });
          break;
        default:
          console.log("Message non reconnu:", message);
      }
    };
    // Mettre en place l'écouteur d'événements WebSocket
    ws.onmessage = handleWebSocketMessage;


  }
    , [ws, navigate]);

  useEffect(() => {
    if (allowed) {
      sessionStorage.removeItem('canAccessRestart');
    }
  }, [allowed]);

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  const handleIfYes = () => {
    var ROOM = localStorage.getItem('UNITY');
    try {
      ws.send(ROOM + ":CHECK");

      ws.onmessage = function (event) {
        var message = event.data;
        console.log(message)
        if (message === ROOM + ":YES") {
          ws.onmessage = null;
          // Autorisation de navigation
          sessionStorage.setItem("canAccessMediaSelect", "true");

          navigate("/mediaSelect", {
            state: { fromRoom: true }
          });
        }
      };

    } catch (error) {
      console.error('Erreur lors de l\'envoi des données via WebSocket :', error);
    }

  };

  const handleIfNo = () => {
    navigate('/');
  };

  return (
    <div className="boxform">
      <h1 className="title">{translations.restart.title}</h1>
      <div className="buttons-container" style={{ display: 'flex', flexDirection: 'column', gap: '15px', marginTop: '30px', width: '100%', maxWidth: 'min(400px, 90vw)' }}>
        <button onClick={handleIfYes} className="submit-button">{translations.restart.yes}</button>
        <button onClick={handleIfNo} className="submit-button" style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>{translations.restart.no}</button>
      </div>
    </div>
  );
};
export default Restart;
